// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3xrA8","left":"StickyBox_left__3AlXC","right":"StickyBox_right__Adrru"};